"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var DealerPriceClientService = /** @class */ (function (_super) {
    __extends(DealerPriceClientService, _super);
    function DealerPriceClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param params The `DealerPriceClientService.GetTrimPriceByDealeridByTrimidGETParams` containing the following parameters:
     *
     * - `trimId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetTrimPriceByDealeridByTrimidGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerPrice/GetTrimPrice/" + params.dealerId + "/" + params.trimId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r.clone({ body: parseFloat(_r.body) });
        }));
    };
    /**
     * @param params The `DealerPriceClientService.GetTrimPriceByDealeridByTrimidGETParams` containing the following parameters:
     *
     * - `trimId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetTrimPriceByDealeridByTrimidGET = function (params) {
        return this.GetTrimPriceByDealeridByTrimidGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `DealerPriceClientService.GetTrimPlanPriceGETParams` containing the following parameters:
     *
     * - `trimId`:
     *
     * - `pricingPlanId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetTrimPlanPriceGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        if (params.trimId != null)
            __params = __params.set('trimId', params.trimId.toString());
        if (params.pricingPlanId != null)
            __params = __params.set('pricingPlanId', params.pricingPlanId.toString());
        if (params.dealerId != null)
            __params = __params.set('dealerId', params.dealerId.toString());
        var req = new http_1.HttpRequest('GET', this.rootUrl + "/api/DealerPrice/GetTrimPlanPrice", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `DealerPriceClientService.GetTrimPlanPriceGETParams` containing the following parameters:
     *
     * - `trimId`:
     *
     * - `pricingPlanId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetTrimPlanPriceGET = function (params) {
        return this.GetTrimPlanPriceGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `DealerPriceClientService.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGETParams` containing the following parameters:
     *
     * - `vehicleType`:
     *
     * - `msrp`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerPrice/GetAdjustedInventoryVehiclePrice/" + params.dealerId + "/" + params.vehicleType + "/" + params.msrp), __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r.clone({ body: parseFloat(_r.body) });
        }));
    };
    /**
     * @param params The `DealerPriceClientService.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGETParams` containing the following parameters:
     *
     * - `vehicleType`:
     *
     * - `msrp`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGET = function (params) {
        return this.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `DealerPriceClientService.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGETParams` containing the following parameters:
     *
     * - `year`:
     *
     * - `trimId`:
     *
     * - `modelId`:
     *
     * - `makeId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerPrice/GetDealerPrices/" + params.dealerId + "/" + params.makeId + "/" + params.year + "/" + params.modelId + "/" + params.trimId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `DealerPriceClientService.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGETParams` containing the following parameters:
     *
     * - `year`:
     *
     * - `trimId`:
     *
     * - `modelId`:
     *
     * - `makeId`:
     *
     * - `dealerId`:
     *
     * @return Success
     */
    DealerPriceClientService.prototype.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGET = function (params) {
        return this.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param prices undefined
     * @return Success
     */
    DealerPriceClientService.prototype.UpdateDealerPricesPATCHResponse = function (prices) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = prices;
        var req = new http_1.HttpRequest('PATCH', this.rootUrl + "/api/DealerPrice", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param prices undefined
     * @return Success
     */
    DealerPriceClientService.prototype.UpdateDealerPricesPATCH = function (prices) {
        return this.UpdateDealerPricesPATCHResponse(prices).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    DealerPriceClientService.GetTrimPriceByDealeridByTrimidGETPath = '/api/DealerPrice/GetTrimPrice/{dealerId}/{trimId}';
    DealerPriceClientService.GetTrimPlanPriceGETPath = '/api/DealerPrice/GetTrimPlanPrice';
    DealerPriceClientService.GetAdjustedInventoryVehiclePriceByDealeridByVehicletypeByMsrpGETPath = '/api/DealerPrice/GetAdjustedInventoryVehiclePrice/{dealerId}/{vehicleType}/{msrp}';
    DealerPriceClientService.GetDealerPricesByDealeridByMakeidByYearByModelidByTrimidGETPath = '/api/DealerPrice/GetDealerPrices/{dealerId}/{makeId}/{year}/{modelId}/{trimId}';
    DealerPriceClientService.UpdateDealerPricesPATCHPath = '/api/DealerPrice';
    DealerPriceClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DealerPriceClientService_Factory() { return new DealerPriceClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: DealerPriceClientService, providedIn: "root" });
    return DealerPriceClientService;
}(base_service_1.BaseService));
exports.DealerPriceClientService = DealerPriceClientService;
